import { Injectable } from "@angular/core";
import { NativeDateAdapter } from "@angular/material/core";

@Injectable({
  providedIn: 'root'
})


export class FrenchDateProvider extends NativeDateAdapter {

  parse(value: string) {
    const it = value.split('/');
    if (it.length === 3) {
      return new Date(+it[2], +it[1] - 1, +it[0], 12);
    }
    return new Date();
  }

}
